import React, { useState, useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { SEOHead } from "../components/SEOHead";
import { Sidebar } from "../components/Layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPostPage({ navPages }) {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seoPaused, setSeoPaused] = useState(false);
  useEffect(() => { setLoading(true); axios.get(`${API}/blog/${slug}`).then(r => setPost(r.data)).catch(() => setPost(null)).finally(() => setLoading(false)); }, [slug]);
  useEffect(() => { axios.get(`${API}/seo-status`).then(r => setSeoPaused(!!r.data.paused)).catch(() => {}); }, []);
  if (loading) return <><div className="page-header"><h1>Loading...</h1></div><div className="main-layout"><div className="loading-spinner"></div><Sidebar navPages={navPages} /></div></>;
  if (!post) return <><div className="page-header"><h1>Post Not Found</h1></div><div className="main-layout"><div className="content-panel"><p>Post not found.</p></div><Sidebar navPages={navPages} /></div></>;
  return (
    <div data-testid="blog-post-page">
      <SEOHead title={post.title} description={post.meta_desc} keywords={post.keywords} noindex={seoPaused} />
      <div className="page-header"><h1>{post.title}</h1></div>
      <div className="main-layout"><div className="main-content"><div className="content-panel">
        {post.featured_image && <img src={post.featured_image} alt={post.featured_image_alt || post.title} className="blog-featured-image" loading="lazy" width="800" height="450" data-testid="blog-featured-image" />}
        <div className="blog-meta" style={{ marginBottom: 16 }}>{new Date(post.date).toLocaleDateString()} | {post.author}</div><div dangerouslySetInnerHTML={{ __html: post.content }} /><div style={{ marginTop: 24 }}><Link to="/cleaning-news" style={{ color: "#0056b3" }}>&larr; Back to Cleaning News</Link></div></div></div><Sidebar navPages={navPages} /></div>
    </div>
  );
}

export function BlogRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/cleaning-news/${slug}`} replace />;
}
